import React, { FunctionComponent } from 'react';

import { FlybuysStep as CommonFlybuysStep } from 'scenes/common/components/Steps';
import { FunnelType } from 'scenes/common/types';
import {
  hasFlybuys,
  getFlybuysNumber,
  hasQuoteNumber,
  getCoverType,
} from 'scenes/landlord/selectors';
import { LandlordFullPageProps } from 'scenes/landlord/types';
import config, { FeatureToggleState } from 'shared/config';

const FlybuysStep: FunctionComponent<LandlordFullPageProps> = ({
  funnelState,
  onNext,
  onUpdateQuoteDetails,
  onCreateQuote,
  onUpdateFlybuys,
}) => {
  const handleOnSubmit = () => {
    if (config.featureToggles.skipLandlordPromoPage !== FeatureToggleState.ON) {
      return onNext;
    }

    return hasQuoteNumber(funnelState) ? onUpdateQuoteDetails : onCreateQuote;
  };
  return (
    <CommonFlybuysStep
      onSubmit={handleOnSubmit()}
      defaultHasFlybuysStateValue={hasFlybuys(funnelState)}
      defaultFlybuysNumberStateValue={getFlybuysNumber(funnelState)}
      submitButtonCaption={
        config.featureToggles.skipLandlordPromoPage === FeatureToggleState.ON
          ? 'Get your quote'
          : 'Next'
      }
      onUpdateFlybuys={onUpdateFlybuys}
      coverType={getCoverType(funnelState)}
      productType={FunnelType.Landlord}
    />
  );
};

export default FlybuysStep;
